module.exports = __webpack_public_path__ + "40382f99b25ba6fd9ab114f1baaded93.png";